import { content } from '../reducers/content.reducer';
import {
    makeDELETERequest,
    makeGETRequest,
    makePOSTRequest,
} from '../utils/Axios';

export const minimized_content_groupActions = {
  getMinimizedContentGroup,
  createMinimizedContentGroup,
  removeMinimizedContentGroup
}

export function getMinimizedContentGroup(props) {
  return function (dispatch) {
    try{
        props?.onBefore?.();
        makeGETRequest(`/api/v1/minimized_content_groups/`)
        .then(response => {
            if(response.data.status === "ok"){
                props?.onSuccess?.(response);
            }else {
                console.error(response.data.message);
                props?.onError?.(response);
            }
        })
    }catch(e){
      console.error(e);
    }
  }
}

export function createMinimizedContentGroup(props) {
  return function (dispatch) {
    try {
      props?.onBefore?.();
      makePOSTRequest(`/api/v1/minimized_content_groups/`, { content_group_id: props?.content_group_id })
        .then(response => {
          if (response.data.status === "ok") {
            props?.onSuccess?.(response);
          } else {
            console.error(response.data.message);
            props?.onError?.(response);
          }
        })
    } catch (e) {
      console.error(e);
    }
  }
}

export function removeMinimizedContentGroup(props) {
    return function (dispatch) {
        try {
        props?.onBefore?.();
        makeDELETERequest(`/api/v1/minimized_content_groups?content_group_id=${props?.content_group_id}`)
            .then(response => {
            if (response.data.status === "ok") {
                props?.onSuccess?.(response);
            } else {
                console.error(response.data.message);
                props?.onError?.(response);
            }
            })
        } catch (e) {
        console.error(e);
        }
    }
}